import { styled } from 'styled-components'
import pattern from '../assets/pattern.svg'

// content
export const StyledMain = styled.main(({ theme }) => `
  grid-area: content;
  background: ${theme.colors.palette.white};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  // see StyledHeader
  width: 100vw;  /* ensures it's bound to the viewport width */
  overflow-x: hidden;  /* prevents horizontal scroll */
  max-width: 100%;  /* prevents exceeding viewport width */
  box-sizing: border-box;  /* ensures padding doesn't extend it */
`)

export const StyledSection = styled.section<{
  $willReverse?:boolean,
}>`
  display: flex;
  flex-direction: row;
  /* flex-wrap: wrap; */
  align-items: center;
  justify-content: center;
  width: 100%;
  height: ${({ theme }) => theme.sizes.heights.section};
  background: ${({ theme }) => theme.colors.palette.darkBlack};
  border-bottom: ${({ theme }) =>
    `${theme.sizes.heights.border} solid ${theme.colors.contrast.darkBlack}`};

  @media (max-width: ${({ theme }) => theme.screens.medium}) {
    flex-direction: ${({ $willReverse }) => $willReverse ? 'column-reverse' : 'column'};
    height: ${({ theme }) => theme.sizes.heights.sectionMedium};
    padding-top: ${({ theme }) => theme.sizes.padding.sectionMedium};
  }
`

export const StyledText = styled.div`
  width: 80%;
  height: auto;
  font-size: 1.2em;
  color: ${({ theme }) => theme.colors.palette.ghostWhite};
`

const CardRoot = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: ${({ theme }) => theme.colors.palette.ghostWhite};
`

const StyledCardSmall = styled(CardRoot)`
  flex: 2;

  @media (max-width: ${({ theme }) => theme.screens.medium}) {
    flex: 1;
    width: 100%;
  }
`

const StyledCardLarge = styled(CardRoot)`
  flex: 3;
  gap: 6vw;

  @media (max-width: ${({ theme }) => theme.screens.medium}) {
    flex: 1;
    gap: 4.5vw;
    width: 100%;
  }
`

export const StyledCardSmallDarkBlack = styled(StyledCardSmall)`
  background-color: ${({ theme }) => theme.colors.palette.darkBlack};
`

export const StyledCardLargeLightBlack = styled(StyledCardLarge)`
  height: 88%;
  margin: 0 1em;
  background: url('${pattern}');
  background-attachment: fixed;
  border-radius: 2em;

  @media (max-width: ${({ theme }) => theme.screens.medium}) {
    border-radius: 0;
    background-attachment: scroll;
  }
`

// other
export const StyledLink = styled.a`
  font-size: 1em;
  color: ${({ theme }) => theme.colors.link.regular};
  text-decoration: none;
  transition: 0.3s;

  &:hover {
    color: ${({ theme }) => theme.colors.link.hover};
  }
`
